import { Theme, FAIcon, useTranslation } from '@nextgen-web-framework/all';
import { UsernameType } from '@commerce-identity-webcomponents/sdk/types';
import { MAX_OTP_REQUESTS_BEFORE_HINT } from '../../utils/Constants';
import styles from './OtpInvalidLabel.module.scss';

type OtpInvalidLabelProps = {
  otpRequestCount?: number;
  userNameType?: UsernameType;
};

const OtpInvalidLabel = ({ otpRequestCount: otpRequestCount = 1, userNameType }: OtpInvalidLabelProps) => {
  const t = useTranslation();

  const showEnhancedMessage = otpRequestCount >= MAX_OTP_REQUESTS_BEFORE_HINT;

  let messageKey = 'identity.VerifyOtp.errorText';

  if (showEnhancedMessage) {
    if (userNameType === UsernameType.PHONE) {
      messageKey = 'identity.VerifyOtp.errorTextAfterMultipleRequestsForPhone';
    } else {
      // Default to email message for EMAIL, EMAIL_PHONE, or undefined
      messageKey = 'identity.VerifyOtp.errorTextAfterMultipleRequestsForEmail';
    }
  }

  return (
    <div data-testid="otp-invalid-test-id" className={styles['identity-otp-invalid-label']}>
      <span className={styles['icon']}>
        <FAIcon theme={Theme.ERROR} iconName="square-exclamation" />
      </span>
      <span className={styles['title']}>{t(messageKey)}</span>
    </div>
  );
};

export default OtpInvalidLabel;
